import { __ } from '@wordpress/i18n';

/**
 * Shortcode select component.
 */

const DynamicShortcodeInput = ( {
	attributes: { shortcode },
	shortCodeList,
	shortcodeUpdate,
	sidebar = false,
} ) => {
	const updateTitle = ( shortcode ) => {
		const title =
			shortcode.title.length > 30
				? `${ shortcode.title.substring( 0, 25 ) }.... #(${
						shortcode.id
				  })`
				: `${ shortcode.title } #(${ shortcode.id })`;
		return title;
	};

	return (
		<div className="sptp-gutenberg-shortcode editor-styles-wrapper">
			<select
				className="sptp-shortcode-selector"
				onChange={ ( e ) => shortcodeUpdate( e.target.value, sidebar ) }
				value={ shortcode }
			>
				<option value="0">
					{ __(
						'-- Select a view (shortcode) --',
						'testimonial-pro'
					) }
				</option>
				{ shortCodeList?.map( ( shortcode ) => (
					<option
						key={ shortcode.id.toString() }
						value={ shortcode.id.toString() }
					>
						{ updateTitle( shortcode ) }
					</option>
				) ) }
			</select>
		</div>
	);
};

export default DynamicShortcodeInput;
